import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const ResetPasswordElementFields = {
  group: ELEMENT_GROUPS.AUTH,
  label: 'Reset Password',
  icon: 'MailIcon',
  description: 'Sends a user a password reset email',
  properties: [
    'alignment',
    'margin',
    'padding',
    {
      label: 'Back to Login Screen',
      name: 'loginScreen',
      description:
        'The screen to return to after reset or when back to login is clicked',
      default: ' ',
      editor: 'dropdown',
      options: [],
      function: {
        name: 'getAppScreens',
        params: ['app.id']
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Show Button Icon',
      name: 'showButtonIcon',
      editor: 'boolean',
      description: 'If the button should include an icon',
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      label: 'Button Icon',
      name: 'buttonIcon',
      editor: 'icon',
      description: 'The button icon',
      displayWhen: [{ field: 'showButtonIcon', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      name: 'buttonIconSize',
      label: 'Button Icon Size',
      description: '',
      editor: 'iconsize',
      type: 'number',
      default: 14,
      displayWhen: [{ field: 'showButtonIcon', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      name: 'buttonText',
      label: 'Button Text',
      description: '',
      editor: 'textbox',
      type: 'string',
      default: 'Reset Password',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Button Width',
      name: 'buttonWidth',
      editor: 'number',
      description: 'The width of the reset password button',
      default: 200,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'buttonFont',
      label: 'Button Font',
      description: '',
      editor: 'fontsize',
      type: 'font',
      default: 'Login',
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      name: 'buttonTextAlignment',
      label: 'Button Text Alignment',
      description: '',
      editor: 'alignment',
      type: 'string',
      default: 'justify-center',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'buttonPadding',
      label: 'Button Padding',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '10 10 10 10',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'buttonMargin',
      label: 'Button Margin',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '20 0 0 0',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Button Border Radius',
      name: 'buttonBorderRadius',
      editor: 'number',
      description: 'The border radius of the reset password button',
      default: 4,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'buttonColor',
      label: 'Button Color',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#ffffff',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      name: 'buttonBackgroundColor',
      label: 'Button Background Color',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#182fa4',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Show Back to Login Link',
      name: 'showBackToLoginLink',
      editor: 'boolean',
      default: true,
      description: 'Show the back to login link',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      name: 'backToLoginLinkColor',
      label: 'Back to Login Link Color',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#ffffff',
      displayWhen: [
        { field: 'showBackToLoginLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      name: 'backToLoginLinkFont',
      label: 'Back to Login Link Font',
      description: '',
      editor: 'fontsize',
      type: 'font',
      default: 'Login',
      displayWhen: [
        { field: 'showBackToLoginLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      name: 'backToLoginLinkAlignment',
      label: 'Back to Login Link Alignment',
      description: '',
      editor: 'alignment',
      type: 'string',
      default: 'justify-center',
      displayWhen: [
        { field: 'showBackToLoginLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'backToLoginLinkMargin',
      label: 'Back to Login Link Margin',
      description: '',

      editor: 'boundary',
      type: 'string',
      default: '20 0 0 0',
      displayWhen: [
        { field: 'showBackToLoginLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    }
  ]
};

export default ResetPasswordElementFields;
